import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { ClipboardModule } from 'ngx-clipboard';
import { SynergyComponentsModule, SynergyFormsModule } from '@synergy-design-system/angular';
import { DebounceClickDirective } from '@core/directives/debounce-click.directive';
import { IpAddressValidatorDirective } from '@core/directives/ip-address-validator.directive';
import { HasPermissionDirective } from '@core/directives/has-permission.directive';

const ANGULAR_MODULES = [CommonModule, HttpClientModule, FormsModule, ReactiveFormsModule, RouterModule];

@NgModule({
  imports: [
    ...ANGULAR_MODULES,
    SynergyComponentsModule,
    SynergyFormsModule,
    RouterModule,
    NgxMaskDirective,
    NgxMaskPipe,
    ClipboardModule,
    DebounceClickDirective,
    IpAddressValidatorDirective,
    HasPermissionDirective,
  ],
  exports: [
    ...ANGULAR_MODULES,
    SynergyComponentsModule,
    SynergyFormsModule,
    TranslateModule,
    ClipboardModule,
    DebounceClickDirective,
    NgxMaskDirective,
    IpAddressValidatorDirective,
    HasPermissionDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [provideNgxMask(), IpAddressValidatorDirective],
})
export class SharedModule {}
